import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslatedString, untranslatedString } from 'models/translated-string';

@Component({
  selector: 'cs-skinfold-site-measure',
  templateUrl: 'cs-skinfold-site-measure.html',
  host: { 'class': 'skinfold-site-measure' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsSkinfoldSiteMeasureComponent implements OnInit {
  // TranslatedString, not string: a hardcoded English site name here shipped to users
  // undetected once already, because a plain-string input is invisible to every i18n gate.
  @Input() siteName: TranslatedString = untranslatedString('');
  @Input() sitePhoto: string = '';
  @Input() measures: number[] = [];
  @Input() readonly: boolean = false;
  @Input() suggestedPreselectValue: number = undefined;

  @Output() measuresChange = new EventEmitter<number[]>();
  @Output() onValueChange = new EventEmitter<void>();

  measurementIndices = [0, 1, 2, 3, 4];
  private lastEnteredValue: number = undefined;

  ngOnInit() {
    // Ensure we always have 5 measurement slots
    if (!this.measures || this.measures.length === 0) {
      this.measures = new Array(5).fill(undefined);
    } else if (this.measures.length < 5) {
      // Pad with undefined values if less than 5
      while (this.measures.length < 5) {
        this.measures.push(undefined);
      }
    }
  }

  updateMeasure(index: number, value: number) {
    this.measures[index] = value;
    // Track the last entered value for subsequent preselection
    if (value > 0) {
      this.lastEnteredValue = value;
    }
    this.measuresChange.emit(this.measures);
    this.onValueChange.emit();
  }

  getPreselectValue(): number {
    // If we have a last entered value in this session, use it
    if (this.lastEnteredValue !== undefined) {
      return this.lastEnteredValue;
    }
    // Otherwise use the suggested value from the parent (from previous log)
    return this.suggestedPreselectValue;
  }
}